import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function CookiePolicy() {
  return (
    <LegalLayout eyebrow="Legal" title="Cookie Policy" updated="February 2026">
      <p>This Cookie Policy explains what cookies and similar technologies are used on <strong>cakeworldusa.com</strong>, what they do and how you can control them. By continuing to use our site you agree to the use of cookies as described here.</p>

      <Section n="1" title="What is a cookie?">
        <p>A cookie is a small text file that a website places on your device (computer, phone or tablet) when you visit it. Cookies allow the website to remember your actions and preferences over a period of time so you don't have to re-enter them every time you come back or navigate between pages.</p>
      </Section>

      <Section n="2" title="Categories of cookies we use">
        <p><strong>Strictly necessary cookies</strong> — required for the site to function. They enable core features such as maintaining your quote cart, remembering that you dismissed the cookie banner and keeping the admin session secure. These cookies do not require your consent.</p>
        <p><strong>Functional cookies</strong> — remember choices you make on the site to give you an enhanced, more personal experience (for example, the last cake size you selected). These are used only if you consent.</p>
        <p><strong>Analytics cookies</strong> — help us understand how visitors interact with our site by collecting anonymous, aggregated information. We do not currently deploy analytics cookies but may do so in the future with your consent.</p>
        <p><strong>Marketing cookies</strong> — currently not deployed. If enabled in the future, they will only run after your explicit consent.</p>
      </Section>

      <Section n="3" title="Third-party services">
        <p>Some pages may embed third-party content — such as Google Maps for our contact page — which may set their own cookies subject to their own policies. We do not control those cookies and encourage you to review the policies of any third-party service you use.</p>
      </Section>

      <Section n="4" title="How to control cookies">
        <p>You can accept or decline non-essential cookies via our cookie banner. You can also modify your browser settings to block or delete cookies at any time. Please note that disabling strictly necessary cookies may impact the functionality of our site (for example, the quote cart may stop working).</p>
      </Section>

      <Section n="5" title="Local storage">
        <p>In addition to cookies, we may use browser local storage to save your quote cart contents and your cookie preferences so they persist between visits. Local storage is stored on your device and never transmitted to third parties unless you submit a quote or contact form.</p>
      </Section>

      <Section n="6" title="Changes to this policy">
        <p>We may update this Cookie Policy from time to time. The date at the top of this page reflects the most recent revision.</p>
      </Section>

      <Section n="7" title="Contact">
        <p>For any question about this Cookie Policy, please write to <a href="mailto:info@cakeworldusa.com" className="text-brand-red">info@cakeworldusa.com</a>.</p>
      </Section>
    </LegalLayout>
  );
}
